// Module
const siteTools = ( function() {

	/**
	 * Vars
	 */

	let
		_instance = {},
		$printButtons = document.querySelectorAll( '.button--share-print' );

	/**
	 * Private
	 */

	/**
	 * Setup any binding and attributes for all elements.
	 */
	let setup = function() {

		for ( let index = 0; index < $printButtons.length; index++ ) {
			const $element = $printButtons[index];

			$element.addEventListener( 'click', sharePrintClick );
		}
	};

	let sharePrintClick = function() {
		window.print();
	};

	/**
	 * Public
	 */

	_instance.init = function() {
		setup();
	};

	return _instance;

}() );

// Export
export default siteTools;
